/**
 * Why a member's name and number are not the manager's to change — in the
 * manager's words. The backend sends a slug (`reason` on GET, `params` of a
 * 2053 on POST); see moneypool_management/utils/member_identity.py for what
 * each one checks.
 *
 * None of these points at «پروفایل»: a member can fill in a missing name
 * there but cannot change one, so support is the only way for all of them.
 */
const SUPPORT = 'برای اصلاح، با پشتیبانی همیان در ارتباط باشید.'

const NOT_FROM_HERE = `نام و شمارهٔ این عضو از این‌جا قابل تغییر نیست. ${SUPPORT}`

const BLOCK_MESSAGE: { [reason: string]: string } = {
    signed_in:
        'این عضو وارد همیان شده و حسابش دست خودش است؛ نام و شماره‌اش از این‌جا قابل تغییر نیست. برای اصلاح، خودِ عضو با پشتیبانی همیان در ارتباط باشد.',
    has_assets: `برای این عضو حساب بانکی، موجودی کیف پول یا احراز هویت ثبت شده است و نام و شماره‌اش از این‌جا قابل تغییر نیست. ${SUPPORT}`,
    other_boxes: `این عضو در صندوق دیگری هم عضو است و تغییر نام یا شماره‌اش روی آن صندوق هم اثر می‌گذارد. ${SUPPORT}`,
    owner: `نام و شمارهٔ مالک صندوق از این‌جا قابل تغییر نیست. ${SUPPORT}`,
    self: `این حساب خود شماست. برای اصلاح نام یا شماره‌تان با پشتیبانی همیان در ارتباط باشید.`,
}

export const blockMessage = (reason: string | null | undefined) =>
    (reason && BLOCK_MESSAGE[reason]) || NOT_FROM_HERE

/** What was wrong with the input: ours, or the `params` of a 2051. */
const INPUT_ERROR: { [param: string]: string } = {
    name: 'نام یا نام خانوادگی را وارد کنید.',
    first_name: 'نام وارد شده قابل قبول نیست.',
    last_name: 'نام خانوادگی وارد شده قابل قبول نیست.',
    phone_number: 'شماره موبایل معتبر نیست. مثال: ۰۹۱۲۳۴۵۶۷۸۹',
    phone_number_taken:
        'این شماره در همیان به نام شخص دیگری ثبت است. اگر شمارهٔ همین عضو است، با پشتیبانی همیان در ارتباط باشید.',
}

export const SAVE_FAILED =
    'ذخیره نشد. اتصال اینترنت را بررسی کنید و دوباره تلاش کنید.'

export const inputError = (param: string | null | undefined) =>
    (param && INPUT_ERROR[param]) || SAVE_FAILED
